import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from "vue";
import { CompanyService } from "@/services/CompanyService";
import router from "@/router";
import ResourceErrorState from "@/components/layout/ResourceErrorState.vue";
import { useResourceState } from "@/services/useResourceState";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompanyDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

const companyService = new CompanyService();
const companyId = Number(router.currentRoute.value.params.id);
const company = ref<any>({});
const { loading, error, runLoad } = useResourceState();

// Loaded here rather than with a top-level await: an async setup() cannot report a failure,
// so an unknown company id used to render an empty card with no explanation.
const fetchData = () =>
  runLoad(async () => {
    company.value = await companyService.get(companyId);
  });

onBeforeMount(fetchData);

const userHeaders = [
  { title: "Email", key: "email" },
  { title: "Vezetéknév", key: "lastName" },
  { title: "Keresztnév", key: "firstName" },
  { title: "Szerepkör", key: "role" },
];

const __returned__ = { companyService, companyId, company, loading, error, runLoad, fetchData, userHeaders, onBeforeMount, ref, get CompanyService() { return CompanyService }, get router() { return router }, ResourceErrorState, get useResourceState() { return useResourceState } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})